<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!vehicle">
      <span class="loader"></span>
    </span>
    <div class="pl-3 pl-md-4" v-if="vehicle">
      <vehicle-ref-standardized
        :vehicle="vehicle"
        @onEditVehicle="onEditVehicle"
        @vehicleChanged="onViewVehicle"
        gallery-selector
      />
    </div>
    <div v-if="vehicle" class="elite-tabs-wrapper">
      <div class="tabs-wrapper">
        <tabs
          fill
          class="flex-column flex-md-row"
          tabNavWrapperClasses="nav-wrapper tabs-wrapper-nav"
          tabNavClasses="nav elite-tabs"
          :value="currentTab"
          @onTabChanged="tabChanged"
        >
          <tab-pane title="global" id="1" :active="true">
            <span slot="title">
              <i class="fa-regular fa-list"></i>
              {{ $t("COMMON.GLOBAL") }}
            </span>
            <vehicle-view-global
              :vehicle="vehicle"
              :view-header="false"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane title="pictures" id="2" :active="true">
            <span slot="title">
              <i class="fa-regular fa-image"></i>
              {{ $t("COMMON.PICTURES") }}
            </span>
            <vehicle-view-images :vehicle="vehicle" />
          </tab-pane>

          <tab-pane
            title="inspections"
            id="3"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_INSPECTIONS)"
          >
            <span slot="title">
              <i class="fa-regular fa-clipboard-check"></i>
              {{ $t("COMMON.INSPECTIONS") }}
              <!--<span class="badge">2</span>-->
            </span>
            <vehicle-view-inspections
              :vehicle="vehicle"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane
            title="estimations"
            id="4"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_ESTIMATIONS)"
          >
            <span slot="title">
              <i class="far fa-usd-circle"></i>
              {{ $t("COMMON.ESTIMATES") }}
            </span>
            <vehicle-view-estimates
              :vehicle="vehicle"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane
            title="repairs"
            id="5"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_REPAIRS)"
          >
            <span slot="title">
              <i class="fa-regular fa-wrench"></i>
              {{ $t("COMMON.REPAIRS") }}
            </span>
            <vehicle-view-repairs
              :vehicle="vehicle"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane
            title="requests"
            id="6"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_REQUEST)"
          >
            <span slot="title">
              <i class="fa fa-ticket-alt"></i>
              {{ $t("COMMON.REQUESTS") }}
            </span>
            <vehicle-view-requests
              :vehicle="vehicle"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane
            title="customer"
            id="7"
            :active="true"
            v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_CUSTOMER)"
          >
            <span slot="title">
              <i class="fa fa-user"></i>
              {{ $t("COMMON.CUSTOMER") }}
            </span>
            <vehicle-view-customer
              :vehicle="vehicle"
              @vehicleUpdated="get"
              @onEditVehicle="onEditVehicle"
              @onViewVehicle="onViewVehicle"
            />
          </tab-pane>

          <tab-pane
            title="files"
            id="998"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
          >
            <span slot="title">
              <i class="far fa-file-alt"></i>
              {{ $t("COMMON.FILES") }}
            </span>
            <div class="elite-tabs-wrapper-content">
              <list-file-component :object="vehicle" />
            </div>
          </tab-pane>

          <tab-pane
            title="logs"
            id="999"
            v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
          >
            <span slot="title">
              <i class="fa fa-history"></i>
              {{ $t("COMMON.LOGS") }}
            </span>
            <vehicle-view-logs :vehicle="vehicle" />
          </tab-pane>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import hasTabs from "@/mixins/has-tabs";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import VehicleViewGlobal from "../partials/VehicleViewGlobal.vue";
import VehicleViewLogs from "../partials/VehicleViewLogs.vue";
import VehicleViewInspections from "../partials/VehicleViewInspections.vue";
import VehicleViewEstimates from "../partials/VehicleViewEstimates.vue";
import VehicleViewRepairs from "../partials/VehicleViewRepairs.vue";
import VehicleViewRequests from "../partials/VehicleViewRequests.vue";
import VehicleViewImages from "../partials/VehicleViewImages.vue";
import VehicleViewCustomer from "../partials/VehicleViewCustomer.vue";
import VehicleRefStandardized from "@/components/VehicleRefStandardized.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    VehicleViewGlobal,
    VehicleViewLogs,
    ListFileComponent,
    VehicleViewInspections,
    VehicleViewEstimates,
    VehicleViewRepairs,
    VehicleViewRequests,
    VehicleViewImages,
    VehicleViewCustomer,
    VehicleRefStandardized,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    vehicleId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      vehicle: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("vehicles/get", this.vehicleId);
        this.vehicle = this.$store.getters["vehicles/vehicle"];
      } catch (error) {
        this.showRequestError(
          error,
          true,
          this.$t("VEHICLES.FORBIDDEN_ERRORS.VIEW")
        );
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    onEditVehicle() {
      this.$emit("onEditVehicle", this.vehicle);
    },

    onViewVehicle(vehicle = null) {
      if (!vehicle) {
        vehicle = this.vehicle;
      }

      this.$emit("onViewVehicle", vehicle, true);
    },
  },
};
</script>
